import { PlusCircleIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CirclePlus = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <PlusCircleIcon size={Sizes[size]} {...rest} />;
};

CirclePlus.displayName = 'CirclePlus';
